import CompanyAdminDataGrid from './CompanyAdminDataGrid';

export default CompanyAdminDataGrid;
